// @flow
import React from 'react';
import Helmet from 'react-helmet';
import useLandingData from './useLandingData';

const getBreadCrumbs = (breadcrumbs) => {
  const defaultBreadcrumbs = [
    {
      title: 'JustPark',
      url: 'https://www.justpark.com/'
    }
  ];

  const items = [defaultBreadcrumbs[0], ...breadcrumbs];

  const breadcrumbArray = items.map((breadcrumb, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: breadcrumb.title,
    item: breadcrumb.url
  }));

  return `{
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": ${JSON.stringify(breadcrumbArray)}
              }
          `;
};

const LandingMeta = () => {
  const {
    canonical,
    breadcrumbs,
    meta: { title, description }
  } = useLandingData();

  return (
    <Helmet title={title} titleTemplate="%s">
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      <script type="application/ld+json">{getBreadCrumbs(breadcrumbs)}</script>
    </Helmet>
  );
};

export default LandingMeta;
